import React from 'react'
import { ErrorMessage, Field, FieldProps } from 'formik';
import { Form } from 'semantic-ui-react';

interface TextProps extends FieldProps {
  label: string,
  placeholder: string
  type?: string,
  step?: number
}

const FormikInput = ({
    field,
    label,
    placeholder,
    type,
    step
  }: TextProps) => (
    <Form.Field>
      <label>{label}</label>
      <Field step={step} type={type} placeholder={placeholder} {...field} as={Form.Input} fluid/>
      <div style={{ color:'red' }}>
        <ErrorMessage name={field.name} />
      </div>
    </Form.Field>
  );

export default FormikInput;